import PageLayout from "@/components/ui/page-layout";
import SubscriptionDetails from "../components/SubscriptionDetails";
import { Button } from "@/components/ui/button";
import { useNavigate, useParams } from "react-router-dom";

export default function SubscriptionDetailsPage() {
    const navigate = useNavigate()
    const id = useParams().id || ''
    const breadcrumbs = [
        { label: 'Subscriptions', href: '/subscriptions' },
        { label: 'Details' },
    ]
    if (id) {
        breadcrumbs.push({ label: id, href: `/subscriptions/${id}` })
    }
    return (
        <PageLayout
            title="Subscription Details"
            subtitle="View subscription details"
            breadcrumbs={breadcrumbs}
            action={<Button onClick={() => navigate(`/subscriptions/edit/${id}`)}>Edit</Button>}
        >
            <SubscriptionDetails />
        </PageLayout>
    )
}